// test667
(667 && 0);
